import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { InvestmentListModel } from "../investmentList.model";
import { InvestmentService } from "../investment.service";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { InvestmentDialogDeleteComponent } from './investment-dialog-delete.component';
import { InvestmentConst } from '../const';
import { DummyComponent } from '../../../shared/dummy.component';
import { AddFileService } from '../../../shared/components/add-file/add-file.service';
import * as FileSaver from 'file-saver';
import { consts } from '../../../consts';
import { AmortisationTableDialogComponent } from '../amortisation/table-dialog.component';
import { Utils } from '../../../shared/utils';
import { AccountingMovementsService } from '../../accounting/movements/accounting-movements.service';
import { InvestmentDialogPayComponent } from './investment-dialog-pay.component';
import { AccountingManualFormComponent } from '../../accounting/manual/accounting-manual-form.component';
import { TableService } from '../../../shared/components/table/table.service';

@Component({
    selector: 'convfact-investment-list',
    templateUrl: './investment-list.component.html',
    styleUrls: ['./investment.component.css'],
    standalone: false
})
export class InvestmentListComponent implements OnInit {
  currentPage = 1;
  itemsPerPage = 10;
  totalItems = 0;

  typeInvestment = 0;

  dataResultTotals = null;

  constructor(
    private router: Router,
    private investmentService: InvestmentService,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private addFileService: AddFileService,
    public dummy: DummyComponent,
    private accountingMovementsService: AccountingMovementsService,
    private tableService: TableService
  ) { }

  headerTable: any[] = InvestmentConst.headerTable;

  dataSource: InvestmentListModel[] = [];

  showQR: boolean = false;
  empty: boolean = false;
  ready: boolean = false;
  spinner: boolean = false;

  download: boolean = false;

  onSelectedChange(selected: InvestmentListModel[]) {
    const toNum = (v: any) => {
      if (v === null || v === undefined || v === '') return 0;
      if (typeof v === 'string') {
        v = v.replace(/\s/g, '').replace(',', '.');
      }
      const n = Number(v);
      return isNaN(n) ? 0 : n;
    };

    let total = 0;
    let totalPaid = 0;
    let totalUnpaid = 0;

    selected.forEach(row => {
      const rowTotal = toNum(row.total);
      const rowPaid = toNum(row.paid);

      total += rowTotal;
      totalPaid += rowPaid;
      totalUnpaid += total - totalPaid;
    });

    this.dataResultTotals = [
      { alias: 'Total', quantity: total },
      { alias: 'Pagado', quantity: totalPaid },
      { alias: 'Pendiente', quantity: totalUnpaid },
    ];
  }

  //Interacción con la tabla
  onAmountNumberClick(investment) {
    this.pay(investment.uid);
  }

  onDescriptionInvestmentClick(investment) {
    if (investment.image) {
      this.downloadFileImage(investment.uid);
    }

    if (investment.pdf) {
      this.downloadFilePdf(investment.uid);
    }
  }

  onProviderInvestmentClick(investment) {
    this.edit(investment.uid);
  }

  export() {
    this.download = true;
    this.investmentService.exportInvestments().then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName('Inversiones'));
      this.download = false;
    });
  }

  public showTable(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(AmortisationTableDialogComponent, {
      height: '70%',
      width: '80%',
      data: { uid: uid }
    });
  }

  public pay(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    // Buscamos el objeto de inversion y se lo pasamos al modal de pago
    const investmentSelected = this.dataSource.find(x => x.uid === uid);

    this.dialog.open(InvestmentDialogPayComponent, {
      // height: '60%',
      // width: '70%',
      data: { investment: investmentSelected }
    })
      .afterClosed().subscribe(() => {
        this.dummy.redirectTo(this.router.url);
      });
  }

  goAmortisation() {
    this.router.navigate([this.router.url + '/amortisation']);
  }

  createInvestment() {
    this.router.navigate([this.router.url + '/create']);
  }

  displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  edit(uid: string): void {
    this.router.navigate([this.router.url + '/edit' + '/' + uid]);
  }

  public delete(uid: string) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog.open(InvestmentDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  ngOnInit() {
    this.dataSource = [];

    const temp = this.router.url.split('/');

    if (temp.length == 3) {
      const typeInvestmentUrl = temp[2]; // intangible o material

      if (typeInvestmentUrl === 'intangible') {
        this.typeInvestment = 1;
      }

      if (typeInvestmentUrl === 'material') {
        this.typeInvestment = 2;
      }
      this.getList();
      this.getTotal();
    }
  }

  getList() {
    this.investmentService.getListSpecialInvestment(this.typeInvestment, this.currentPage, this.itemsPerPage)
      .then(data => {
        this.tableService.set(data.list);
        this.dataSource = data.list;
        this.totalItems = data.totalItems;
        if (this.dataSource.length === 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      });
  }

  getTotal() {
    this.investmentService.getTotal(this.typeInvestment).then(
      data => {
        this.dataResultTotals = data;
      }
    );
  }

  pageChanged(event: any) {
    this.currentPage = event.page;
    this.getList();
  }

  public downloadFileImage(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.addFileService.downloadFileImage(uid, consts.INVESTMENT_ENTITY, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetFileName('imagen_fichero', consts.EXT_PNG));
    });
  }

  public downloadFilePdf(uid: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.addFileService.downloadFilePDF(uid, consts.INVESTMENT_ENTITY, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetPdfName('Inversión'));
    });
  }

  public amortisationSelected(selectedInvestment) {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    selectedInvestment.forEach(uid => {
      this.investmentService.addAccountingAmortisationInvestment(uid).then((response: string) => {
        this.displayInfo(response);
        this.ready = true;
      })
        .catch(err => {
          this.displayInfo(err['error']['data']);
          this.ready = true;
        });

    })
  }

  public bookInvestmentAmortisation(selectedInvestment): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.ready = false;
    this.investmentService.getBookAmortisation(selectedInvestment, consts.EMPTY_GUID).then(response => {
      FileSaver.saveAs(response, Utils.GetExcelName('Libro_Inversion_Amortización'));
      this.ready = true;
    });
  }

  public addManualAccountMovements(): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.dialog
      .open(AccountingManualFormComponent, {
        width: '60%',
        height: '70%',
        data: {
          accountingMovementId: ''
        }
      })
      .afterClosed().subscribe((result: string) => {
        if (!Utils.IsNullOrEmpty(result)) {
          if (result === 'OK') {
            this.dummy.redirectTo(this.router.url);
          }
        }
      });
  }

  public addAccountingAmortisationInvestment(selectedInvestment: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.ready = false;

    this.investmentService.addAccountingAmortisationInvestment(selectedInvestment).then((response: string) => {
      this.displayInfo(response);
      this.ready = true;
      this.dummy.redirectTo(this.router.url);
    })
      .catch(err => {
        this.displayInfo(err['error']['data']);
        this.ready = true;
      });
  }

  public deleteAccountingAmortisationInvestment(selectedInvestment: string): void {
    if (!Utils.IsTierFour()) {
      this.displayInfo(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE);
      return;
    }

    this.ready = false;

    this.investmentService.deleteAccountingAmortisationInvestment(selectedInvestment).then((response: boolean) => {
      if (response) {
        this.displayInfo('Se ha eliminado correctamente la contabilidad de la amortización');
      } else {
        this.displayInfo('No se ha eliminado la contabilidad de la amortización');
      }
      this.ready = true;
      this.dummy.redirectTo(this.router.url);
    })
      .catch(err => {
        this.displayInfo('Ha ocurrido un error inesperado al eliminar la contabilidad de la amortización');
        this.ready = true;
      });
  }

  public trackByIndex(i: number) { return i; }

}
